export default __webpack_public_path__ + "static/media/icon_Pencil_.59a6956e.svg";